module.exports = __webpack_public_path__ + "img/background.bb5fd9a2.png";